import { TagsOutlined } from "@ant-design/icons";
import { OffersTable } from "components/Tables/OffersTable/OffersTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getOfferHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/offer/")({
    component: OffersPage,
    staticData: {
        permissions: [PermissionEnum.OfferView],
        showInSideMenu: true,
        label: "pages.offer.title",
        icon: <TagsOutlined />,
        sort: 3,
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.offer.title"),
    }),
});

function OffersPage() {
    return (
        <TenantPage headerNavigationItems={getOfferHeaderItems}>
            <OffersTable />
        </TenantPage>
    );
}
